import React from 'react';
import { useRecoilValue } from 'recoil';
import { Box, CircularProgress, Typography } from '@mui/material';
import { authLoadingState, authTokenState, cognitoIdState } from 'features/auth/state/authAtoms';

interface Props {
  children: React.ReactNode;
}

export const AuthGate: React.FC<Props> = ({ children }) => {
  const loading = useRecoilValue(authLoadingState);
  const authToken = useRecoilValue(authTokenState);
  const cognitoId = useRecoilValue(cognitoIdState);

  const isReady = authToken !== '' && cognitoId !== '';

  if (loading) {
    return (
      <Box
        component="div"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: '100vw',
          gap: 2,
        }}
      >
        <CircularProgress color="primary" />
        <Typography variant="body2" color="#1e1e1e">
          認証情報を取得しています...
        </Typography>
      </Box>
    );
  }

  if (!isReady) {
    return (
      <Box
        component="div"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: '100vw',
          gap: 1,
        }}
      >
        <Typography variant="body1" color="#1e1e1e">
          認証情報を取得できませんでした。
        </Typography>
        <Typography variant="body2" color="#1e1e1e">
          ページを再読み込みしてください。
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};
